export const switchRole = `mutation($roleID: String!){
  switchKbRole(input : $roleID)
  }`
  